/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Shopping_TitleInputs */

const en_plan_shopping_title = /** @type {(inputs: Plan_Shopping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week's shopping`)
};

const de_plan_shopping_title = /** @type {(inputs: Plan_Shopping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einkauf der Woche`)
};

/**
* | output |
* | --- |
* | "This week's shopping" |
*
* @param {Plan_Shopping_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_shopping_title = /** @type {((inputs?: Plan_Shopping_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Shopping_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_shopping_title(inputs)
	return en_plan_shopping_title(inputs)
});